import { useState } from 'react'
import { CustomerApplication } from '../../../utilities/CustomerData'

export function ApplicationExtension({ _customerApplication, handleExtensionQuestion }) {
  const customerApplication = new CustomerApplication(_customerApplication)

  const [hasExtension, setHasExtension] = useState(customerApplication.isSelfEmployed)
    
  return  (
    <div className='w-full h-full flex flex-col items-center lg:justify-center overflow-y-auto mt-4'>
      <div className='w-full h-full flex flex-col items-center justify-center px-4 py-6'>
        <p className='lg:text-2xl text-xl font-bold text-center mb-8'>Was your 2021 tax return submitted past the original due date (i.e., with an extension)?</p>
        <div className='flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-10 mb-10'>
          <label className='flex items-center space-x-3 cursor-pointer'>
            <input
              type='radio'
              name='employmentStatus'
              value='Yes'
              checked={hasExtension === 'Yes'}
              onChange={() => setHasExtension('Yes')}
              className='form-radio text-setcg h-5 w-5'
            />
            <span className='text-lg'>Yes</span>
          </label>
          <label className='flex items-center space-x-3 cursor-pointer'>
            <input
              type='radio'
              name='employmentStatus'
              value='No'
              checked={hasExtension === 'No'}
              onChange={() => setHasExtension('No')}
              className='form-radio text-setcg h-5 w-5'
            />
            <span className='text-lg'>No</span>
          </label>
          <label className='flex items-center space-x-3 cursor-pointer'>
            <input
              type='radio'
              name='employmentStatus'
              value='No'
              checked={hasExtension === "I'm not sure"}
              onChange={() => setHasExtension("I'm not sure")}
              className='form-radio text-setcg h-5 w-5'
            />
            <span className='text-lg'>I'm not sure</span>
          </label>
        </div>
        <div className='flex flex-row items-center gap-4'>
          <button
            onClick={() => handleExtensionQuestion(hasExtension)}
            disabled={!hasExtension}
            className={`px-8 py-2 text-white rounded-md transition-colors duration-200 ${!hasExtension ? 'bg-gray-400 cursor-not-allowed' : 'bg-primaryColor hover:bg-primaryDarkColor transition duration-200'}`}>
            Next
          </button>
        </div>
      </div>
    </div>
  )
}